module.exports = __webpack_public_path__ + "img/Declaraguate.e3a5ca5e.png";